import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";

import { Trans, useTranslation } from 'react-i18next';

import {
    Grid,
    IconButton,
    Table,
    TableBody,
    TableContainer,
    TableHead,
    Typography,
    Paper
} from "@mui/material"

import CardElement from "./CardElement";

import StyledTableCell from "../../../styled/TableCell";
import StyledTableRow from "../../../styled/TableRow";

import CalendarIcon from "../../../icons/CalendarIcon";
import TrashIcon from "../../../icons/TrashIcon";
import DashboardIcon from "../../../icons/DashboardIcon";
import DownArrowIcon from '../../../icons/DownArrowIcon';
import UpArrowIcon from '../../../icons/UpArrowIcon';

import ProjectListHeader from './ProjectListHeader';
import { AddBox, Edit } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import { setProjectListFilters } from '../../../../store/actions/FilterView';
import store from "../../../../store";

function StyledProjectList(props)
{
    const { 
        height,
        handleDeleteClicked,
        isExpanded,
        sort,
        sortArray,
        projects,
        setHeight,
        handleClick,
        title,
        type,
        setVersionsDialogOpen,
        setSelectedFloorPlan,
        screenshotsLoaded
    } = props;

    const { t } = useTranslation();
    const navigate = useNavigate();

    const [, updateState] = useState();

    const forceUpdate = useCallback(() => updateState({}), []);

    const projectListFilterView = useSelector((state) => state.filterView.projectListFilterView);

    useEffect(() => {
        function handleResize() {
            reCalculateHeight();
        }

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, [])

    useEffect(() => { reCalculateHeight(); }, [isExpanded]);

    /*
    useEffect(() => {
        isMounted.current = true;

        return () => { beforeUnloadCallback();  isMounted.current = false }
    }, []);
    */

    function reCalculateHeight() {
        const element = document.getElementById('project-list-header');

        setHeight(window.innerHeight - element.clientHeight - 32);
    }

    function beforeUnloadCallback() {
        store.dispatch(setProjectListFilters({'name': null, 'date': null}));
    }

    return (
        <div>
            <Helmet>
                <title>{t('easyBoardOnline')}</title>
            </Helmet>
            <ProjectListHeader nrOfProjects={!projects ? 0 : projects.length} title={title} type={type} />
            <div style={{ padding: '24px'}}>
                { projectListFilterView === 'TileView' &&
                    <Grid container spacing={2} sx={{maxHeight: height+'px', overflowY: 'auto'}}>
                        {projects && projects.length > 0 ? (
                            projects.map((project) => (
                                <Grid key={project.id} item xl={1.71} lg={2.4} md={3} sm={4} xs={12}>
                                    <CardElement
                                        item={project}
                                        t={t}
                                        handleDeleteClicked={handleDeleteClicked}
                                        handleClick={handleClick}
                                        type={type}
                                        setVersionsDialogOpen={setVersionsDialogOpen}
                                        setSelectedFloorPlan={setSelectedFloorPlan}
                                        screenshot={project.screenshot}
                                    />
                                </Grid>
                            ))
                        ) : (
                            <Typography>{t('No projects found!')}</Typography>
                        )}
                    </Grid>
                }
                { projectListFilterView === 'ListView' &&
                    <TableContainer component={Paper} sx={{maxHeight: isExpanded ? '74vh' : '85vh'}}>
                        <Table stickyHeader sx={{ minWidth: 650}} aria-label="simple table">
                            <TableHead style={{zIndex: 0}}>
                                <StyledTableRow>
                                    <StyledTableCell>
                                        <Grid container alignItems='center' onClick={() => sort('name')}>
                                            <Grid item>
                                                <DashboardIcon />
                                            </Grid>
                                            <Grid item>
                                                {t('Project')}
                                                {
                                                    !sortArray 
                                                        ? ''
                                                        :  sortArray['name'] === 'ASC'
                                                            ? <UpArrowIcon />
                                                            : sortArray['name'] === 'DESC'
                                                                ? <DownArrowIcon />
                                                                : ''
                                                }
                                            </Grid>
                                        </Grid>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <Grid container alignItems='center' onClick={() => sort('date')}>
                                            <Grid item>
                                                <CalendarIcon />
                                            </Grid>
                                            <Grid item>
                                                {t('Date')}
                                                {
                                                    !sortArray 
                                                        ? ''
                                                        :  sortArray['date'] === 'ASC'
                                                            ? <UpArrowIcon />
                                                            : sortArray['date'] === 'DESC'
                                                                ? <DownArrowIcon />
                                                                : ''
                                                }
                                            </Grid>
                                        </Grid>
                                    </StyledTableCell>
                                    <StyledTableCell align="right">
                                        {t('Actions')}
                                    </StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {projects && projects.length > 0 ? (
                                    projects.map((project) => (
                                        <StyledTableRow
                                            key={project.id}
                                            sx={{ cursor: 'pointer' }}
                                            onClick={() => handleClick(project.id)}
                                        >
                                            <StyledTableCell>
                                                {project.name}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {new Date(project.created_at).toLocaleDateString()}
                                            </StyledTableCell>
                                            <StyledTableCell align="right">
                                                {
                                                    type == 'floorPlan' && (
                                                        <IconButton
                                                            onClick={(event) => {
                                                                event.preventDefault();
                                                                event.stopPropagation();
                
                                                                navigate('/app/easy-floor/edit/'+project.id);
                                                            }}
                                                        >
                                                            <Edit style={{color: "#638CA3"}} />
                                                        </IconButton>
                                                    )
                                                }
                                                {
                                                    type == 'floorPlan' && project.multiple_versions_enabled ? (
                                                        <IconButton
                                                            onClick={(event) => {
                                                                event.preventDefault();
                                                                event.stopPropagation();
                
                                                                setVersionsDialogOpen(true);
                                                                setSelectedFloorPlan(project);
                                                            }}
                                                        >
                                                            <AddBox style={{color: "#638CA3"}} />
                                                        </IconButton>
                                                    ) : null
                                                }
                                                <IconButton onClick={(event) => handleDeleteClicked(event, project.id)}>
                                                    <TrashIcon />
                                                </IconButton>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    ))
                                ) : (
                                    <StyledTableRow>
                                        <StyledTableCell colSpan={3}>
                                            <Trans>No projects found!</Trans>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                }
            </div>
        </div>
    )
}

export default StyledProjectList;